import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'

import { history } from "../../../appRedux/store";
import { getTypParkedAPI, getVisitReportAPI } from '../../../services/typist-service';
import { FETCH_PARKED_VISITS, FETCH_PARKED_VISITS_ERROR, FETCH_PARKED_VISITS_START, FETCH_PARKED_VISITS_SUCCESS, VIEW_PARKED_VISIT, VIEW_PARKED_VISIT_ERROR, VIEW_PARKED_VISIT_START, VIEW_PARKED_VISIT_SUCCESS, SET_PARKED_SEARCH_FILTER_AND_SORT, SET_PARKED_VISIT_PAGINATION } from '../../actions/typist/typistParkedAction';
import { fetchRadiologistTemplates } from '../../actions/typist/typistWorklistAction';

const getRoutingLocation = (state) => state.routing.location;

function* fetchParkedVisits({ payload }) {
    try {
        yield put({ type: FETCH_PARKED_VISITS_START })
        const response = yield call(getTypParkedAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_PARKED_VISITS_SUCCESS, visits: response.data.typParkedVisits });
            yield put({ type: SET_PARKED_VISIT_PAGINATION, pagination });
            yield put({ type: SET_PARKED_SEARCH_FILTER_AND_SORT, payload: { ...payload } });
        } else {
            if (response.error) {
                yield put({ type: FETCH_PARKED_VISITS_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: FETCH_PARKED_VISITS_ERROR, error: response.error })
                message.error('Failed to fetch parked visits!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_PARKED_VISITS_ERROR, error })
        message.error('Failed to fetch parked visits!');
    }
}

function* viewParkedVisit({ visit }) {
    yield put({ type: VIEW_PARKED_VISIT_START })
    const { pathname } = yield select(getRoutingLocation);
    const response = yield call(getVisitReportAPI, visit.risId, visit.reportId, visit.visitNo);
    if (response.success) {
        yield put({
            type: VIEW_PARKED_VISIT_SUCCESS,
            report: {
                ...response.visitReport
            }
        });
        // yield put(fetchRadiologistTemplates(visit.radiologistCode));
        history.push({
            pathname: '/typ/report-editor',
            state: {
                from: pathname
            }
        });
    } else {
        if (response.error) {
            yield put({ type: VIEW_PARKED_VISIT_ERROR, error: response.error })
            message.error(response.error);
        } else {
            yield put({ type: VIEW_PARKED_VISIT_ERROR, error: response.error })
            message.error('Failed to view visit!');
        }
    }
}

function* typistParkedWatcher() {
    yield takeEvery(FETCH_PARKED_VISITS, fetchParkedVisits)
    yield takeLatest(VIEW_PARKED_VISIT, viewParkedVisit)
}

export default function* rootSaga() {
    yield all([
        typistParkedWatcher(),
    ]);
}